export const getGroupLevelEmailMessage = (mismatchColumns: Array<string>, data: any) => {
  const columnNamesArr = mismatchColumns.map((col: string) => {
    return col.split(' - ')[1];
  });
  const columnText = columnNamesArr.join(', ');
  const textMsg = `Dear ${data?.['Vendor - Vendor Name']}, \n\nThere seems to be a mismatch in the Invoice no ${data?.['2A - Invoice No']} dated ${data?.['2A - Invoice dt']} in ${columnText} values. Please correct the data for this invoice. \n\nRegards,`;
  return textMsg;
}